import { safeHtmlDirective } from '@star/directives';
import { Lazyload } from 'vant';

export async function initApplication(app) {
  // 注册全局指令
  app.directive('safe-html', safeHtmlDirective);
  app.use(Lazyload);
}
